import { Download, type IconProps } from "@phosphor-icons/react";

export function DownloadIcon(props: IconProps) {
  return <Download size={24} weight="regular" {...props} />;
}
